import {
  Button,
  FormProvider,
  MainLayout,
  OneColumnStack,
  RHFSelect,
  Section,
} from "@arp/react-ndbx";
import { yupResolver } from "@hookform/resolvers/yup";
import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Page from "../../components/Page";
import {
  ccProcessingAccountName,
  ccProcessingAction,
} from "../../config/dropdownSelectValues/selectValues";
import { pageName } from "../../config/pageInfo/pageNames";
import { PATH_CONTACT_CENTER } from "../../routes/paths";
import { ccProcessingSchema } from "../../schema/retrieveQuoteSchema";

function ProcessingLandingPageCC() {
  const navigate = useNavigate();

  const methods = useForm({
    resolver: yupResolver(ccProcessingSchema),
    mode: "all",
    reValidateMode: "all",
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    setValue("ccAccountName", ccProcessingAccountName[0].value);
  }, []);

  const onSubmit = (data) => {
    try {
      if (data?.ccAction === "search") {
        navigate(PATH_CONTACT_CENTER.retrieveQuote);
      } else {
        navigate(PATH_CONTACT_CENTER.openingScript);
      }
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <>
      <Page
        title="Processing Landing Page"
        identifier={pageName.CC_PROCESSING_LANDING_PAGE}
      >
        <MainLayout
          maxWidth="lg"
          sx={{
            mt: 8,
            mb: 5,
            outline: "0px solid purple",
            minHeight: "100vh",
          }}
        >
          <Page title="CC Processing page" identifier="cc-processing-page">
            <Section md={8} mt={8}>
              <Section md={10} textAlign="left" mb={3}>
                <Typography variant="h3-bold">
                  Contact Centre Processing
                </Typography>
              </Section>
              <Section md={10} textAlign="left" mb={4}>
                <Typography variant="p2">
                  Please select an account and an action
                </Typography>
              </Section>
              <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Section md={10} mb={4}>
                  <RHFSelect
                    name="ccAccountName"
                    label="Account name"
                    variant="standard"
                    items={ccProcessingAccountName}
                    defaultValue={ccProcessingAccountName[0].value}
                  />
                </Section>
                <Section md={10} mb={9}>
                  <RHFSelect
                    name="ccAction"
                    label="Action"
                    variant="standard"
                    items={ccProcessingAction}
                  />
                </Section>
                <OneColumnStack flexShrink={1}>
                  <Button
                    id="cc-processing-continue"
                    ariaLabel="continue"
                    variant="contained"
                    color="primary"
                    size="medium"
                    disabled={!isValid}
                    type="submit"
                  >
                    Continue
                  </Button>
                </OneColumnStack>
              </FormProvider>
            </Section>
          </Page>
        </MainLayout>
      </Page>
    </>
  );
}

export default ProcessingLandingPageCC;
